<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-position="right"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <!-- 物资类别 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资类别">
            <el-input
              v-model="queryParams.categoryName"
              placeholder="请输入物资类别"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 物资名称 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资名称">
            <el-input
              v-model="queryParams.assetName"
              placeholder="请输入物资名称"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 入库时间 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="入库时间">
            <el-date-picker
              v-model="queryParams.inDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
              style="width: 100%"
              @change="handleDateChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 按钮区域 -->
      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button :disabled="isExporting" @click="debouncedHandleExport">
          {{ isExporting ? "导出中..." : "导出" }}
        </el-button>
      </div>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <!-- 勾选列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="categoryName" label="物资类别" />
      <el-table-column prop="assetName" label="物资名称" />
      <el-table-column prop="count" label="数量" />
      <el-table-column prop="unitPrice" label="单价" />
      <el-table-column prop="totalPrice" label="金额" />
      <el-table-column prop="creatorName" label="入库人" />
      <el-table-column prop="createTime" label="入库时间" />
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />
  </div>
</template>

<script>
import { dailyAssetsStockPage, dailyAssetsStockExport } from "@/api/material";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile, debounce } from "@/utils/util";

export default {
  name: "DailyMaterialTab",
  components: { PaginationBar },
  data() {
    return {
      queryParams: {
        categoryName: "",
        assetName: "",
        inDateRange: [],
      },
      startCreateTime: "",
      endCreateTime: "",
      tableData: [],
      total: 0, // 总数据条数，实际应该通过 API 请求获取
      pageSize: 10, // 每页展示条数
      currentPage: 1, // 当前页
      isExporting: false, // 导出按钮的禁用状态
      debouncedHandleExport: null,
      selectedIds: [],
    };
  },
  created() {
    this.handleQuery();
    // 初始化防抖方法
    this.debouncedHandleExport = debounce(this.handleExport.bind(this), 300);
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.id); // 提取勾选行的 id
    },
    // 导出方法
    handleExport() {
      if (!this.selectedIds.length) {
        // 提示请先勾选
        return this.$message.warning("请先勾选要导出的数据");
      }

      // 开始导出，禁用按钮
      this.isExporting = true;
      dailyAssetsStockExport(this.selectedIds)
        .then((res) => {
          downloadFile(
            res.data,
            "日常消耗入库记录数据.xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
        })
        .finally(() => {
          // 导出完成，启用按钮
          this.isExporting = false;
        });
    },
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.startCreateTime = dateRange[0]; // "2025-05-30 00:00:00"
        this.endCreateTime = dateRange[1]; // "2025-06-02 23:59:59"
      } else {
        this.startCreateTime = "";
        this.endCreateTime = "";
      }
    },
    // 重置搜索
    resetQuery() {
      this.queryParams = {
        categoryName: "",
        assetName: "",
        inDateRange: [],
      };
      this.startCreateTime = "";
      this.endCreateTime = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      // 实际情况下，可以发起 API 请求，获取数据
      dailyAssetsStockPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        categoryName: this.queryParams.categoryName,
        assetName: this.queryParams.assetName,
        startCreateTime: this.startCreateTime,
        endCreateTime: this.endCreateTime,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
